<script lang="ts" setup>
const props = defineProps<{
  opened: boolean;
}>();
</script>

<template>
  <div
    class="template-shell ap-006-safe-min-screen bg-primary-950 text-default"
  >
    <div class="ap-006-package-switcher">
      <LazyUiPreviewPackageSwitcher
        :opened="props.opened"
        :badge-recommended-props="{
          variant: 'solid',
          class: 'text-primary-900',
        }"
        :radio-group-ui="{
          label: 'font-semibold text-primary-900',
          base: '[&:not(:has([data-state=checked]))]:ring-primary-700',
        }"
        :popover-ui="{
          arrow: 'fill-white',
        }"
      />
    </div>
    <LazyLHeader
      v-if="props.opened"
    />
    <main class="size-full">
      <slot />
    </main>
  </div>
</template>

<style lang="css">
.template-shell {
  --ap-006-panel-width: 430px;
}

@media (min-width: 1024px) {
  .template-shell {
    --ap-006-panel-width: 520px;
  }
}

@media (min-width: 1536px) {
  .template-shell {
    --ap-006-panel-width: 560px;
  }
}

.ap-006-package-switcher button.pointer-events-auto {
  border-color: rgba(255, 255, 255, 0.22) !important;
  background: rgba(7, 7, 7, 0.54) !important;
  color: #fff !important;
  min-height: 3rem !important;
  padding-inline: 0.9rem !important;
  box-shadow: 0 14px 42px rgba(0, 0, 0, 0.34) !important;
  backdrop-filter: blur(18px);
}

.ap-006-package-switcher > div > div:first-child {
  top: calc(0.75rem + env(safe-area-inset-top)) !important;
  right: auto !important;
  left: calc(0.75rem + env(safe-area-inset-left)) !important;
  justify-content: flex-start !important;
}

.ap-006-package-switcher > div > div.fixed.inset-0 {
  inset: 0 !important;
  justify-content: center !important;
  height: 100vh !important;
  height: 100svh !important;
  max-height: 100svh !important;
  min-height: 100vh !important;
  min-height: 100svh !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.ap-006-package-switcher button.pointer-events-auto:hover {
  background: rgba(255, 255, 255, 0.16) !important;
}

.ap-006-package-switcher button.pointer-events-auto p,
.ap-006-package-switcher button.pointer-events-auto span,
.ap-006-package-switcher button.pointer-events-auto svg {
  color: #fff !important;
}

.ap-006-package-switcher [class*="bg-white/96"] {
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  background: rgba(10, 10, 10, 0.86) !important;
  color: #fff !important;
  box-shadow: 0 24px 72px rgba(0, 0, 0, 0.44) !important;
}

.ap-006-package-switcher [class*="text-neutral-"] {
  color: rgba(255, 255, 255, 0.86) !important;
}

.ap-006-package-switcher [role="radio"],
.ap-006-package-switcher label {
  border-color: rgba(255, 255, 255, 0.16) !important;
  background: rgba(255, 255, 255, 0.08) !important;
  color: #fff !important;
}

.ap-006-package-switcher [role="radio"]:hover,
.ap-006-package-switcher label:hover {
  background: rgba(255, 255, 255, 0.14) !important;
}

@media (min-width: 1024px) {
  .ap-006-package-switcher > div > div:first-child {
    top: calc(1rem + env(safe-area-inset-top)) !important;
    left: calc(1rem + env(safe-area-inset-left)) !important;
  }

  .ap-006-package-switcher button.pointer-events-auto {
    max-width: 15.25rem !important;
  }
}

@supports (min-height: 100dvh) {
  .ap-006-package-switcher > div > div.fixed.inset-0 {
    height: 100dvh !important;
    max-height: 100dvh !important;
    min-height: 100dvh !important;
  }
}
</style>
